import { useState } from 'react';
import { Button, Popover, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as AirControlLogo } from 'assets/icons/Aloft_Air_Control.svg';
import { $black, $white } from 'styles/colors';
import laancScene from 'assets/images/laancScene.png';
import { laancLink } from 'constants/externalLinks';
import { logEvent } from 'actions/firebase';
import { GET_LAANC, GO_TO_AIR_CONTROL } from 'constants/firebase';
import { ReactComponent as LAANCIcon } from 'assets/icons/laancIcon.svg';

const styles = {
	main: {
		paddingTop: 20,
		height: 'fit-content',
		width: 340,
		padding: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center'
	},
	name: {
		fontWeight: 'bold',
		marginBottom: 20,
		textAlign: 'center'
	},
	buttonsContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
		padding: 10
	},
	airControlButton: {
		paddingTop: 10,
		paddingBottom: 10,
		backgroundColor: $black,
		color: $white,
		'&:hover': {
			backgroundColor: $black
		},
		display: 'flex',
		flexDirection: 'column'
	},
	downloadText: {
		fontWeight: 600,
		fontSize: 20,
		marginBottom: 10
	},
	getLAANCButton: {
		textTransform: 'none',
		borderRadius: '20px',
		marginTop: 10
	},
	laancScene: {
		height: 175,
		width: '100%',
		backgroundImage: `url(${laancScene})`,
		backgroundPosition: 'bottom'
	}
};
const GetLAANCModal = () => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const useStyles = makeStyles(styles);
	const classes = useStyles();

	const handleClickGetLaanc = event => {
		logEvent(GET_LAANC);
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const gotToAirControl = () => {
		logEvent(GO_TO_AIR_CONTROL);
		window.open(laancLink);
		handleClose();
	};

	return (
		<div>
			<Button
				variant='contained'
				color='primary'
				onClick={handleClickGetLaanc}
				className={classes.getLAANCButton}
			>
				Get LAANC
			</Button>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'center'
				}}
			>
				<div className={classes.main}>
					<LAANCIcon />
					<Typography variant='h4' component='h4' className={classes.name}>
						Before you fly, get LAANC.
					</Typography>
					<div className={classes.laancScene} />
					<div className={classes.buttonsContainer}>
						<Button
							variant='contained'
							fullWidth
							className={classes.airControlButton}
							onClick={gotToAirControl}
						>
							<AirControlLogo />
						</Button>
					</div>
				</div>
			</Popover>
		</div>
	);
};

export default GetLAANCModal;
